import CONSTANTS from "../utils/constants";

const initialDigitalPRState = {
  campaignList: [],
  totalCampaigns: 0,
  campaignsLoading: false,
  linksDialogOpen: false,
  selectedCampaign: null,
  page: 0,
  perPage: 10,
  campaignFilters: { page: 0, perPage: 10, fromDate: null, toDate: null, searchTerm: null},
  exportDisabled: false,
  linkList: [],
  linksLoading: false,
  linksByMonth: {},
  linksByMonthLoading: false,
  linkAcquisitionsByMonth: {},
  linkAcquisitionsByMonthLoading: false,
  domainRatingDistribution: {},
  domainRatingDistributionLoading: false,
  activeOrderBy: null,
  isVideoOpen: false,
  videoUrl: '',
  currentTable: CONSTANTS.ActiveCampaigns,
  clientNotesOpen: false,
  selectedClientNote: '',
  selectedLinkType: null,
  selectedCampaignType: null,
}

const digitalPRActions = {
   SET_CAMPAIGNS: 'SET_CAMPAIGNS',
   SET_CAMPAIGNS_CHILD: 'SET_CAMPAIGNS_CHILD',
   SET_CAMPAIGNS_LOADING: 'SET_CAMPAIGNS_LOADING',
   SET_LINKS_DIALOG_OPEN: 'SET_LINKS_DIALOG_OPEN',
   SET_SELECTED_CAMPAIGN: 'SET_SELECTED_CAMPAIGN',
   SET_CAMPAIGNS_EXPAND: 'SET_CAMPAIGNS_EXPAND',
   SET_TOTAL_CAMPAIGNS: 'SET_TOTAL_CAMPAIGNS',
   SET_LOADING: 'SET_LOADING',
   SET_CAMPAIGN_FILTER: 'SET_CAMPAIGN_FILTER',
   TOGGLE_EXPORT_BUTTON: 'TOGGLE_EXPORT_BUTTON',
   SET_LINK_LIST: 'SET_LINK_LIST',
   SET_LINKS_LOADING: 'SET_LINKS_LOADING',
   SET_LINKS_BY_MONTH: 'SET_LINKS_BY_MONTH',
   SET_LINKS_BY_MONTH_LOADING: 'SET_LINKS_BY_MONTH_LOADING',
   SET_LINK_ACQUISITIONS_BY_MONTH: 'SET_LINK_ACQUISITIONS_BY_MONTH',
   SET_LINK_ACQUISITIONS_BY_MONTH_LOADING: 'SET_LINK_ACQUISITIONS_BY_MONTH_LOADING',
   SET_DOMAIN_RATING_DISTRIBUTION: 'SET_DOMAIN_RATING_DISTRIBUTION',
   SET_DOMAIN_RATING_DISTRIBUTION_LOADING: 'SET_DOMAIN_RATING_DISTRIBUTION_LOADING',
   SET_ACTIVE_ORDER_BY: 'SET_ACTIVE_ORDER_BY',
   SET_IS_VIDEO_OPEN: 'SET_IS_VIDEO_OPEN',
   SET_VIDEO_URL: 'SET_VIDEO_URL',
   SET_CURRENT_TABLE: 'SET_CURRENT_TABLE',
   SET_CLIENT_NOTES_OPEN: 'SET_CLIENT_NOTES_OPEN',
   SET_SELECTED_CLIENT_NOTE: 'SET_SELECTED_CLIENT_NOTE',
   SET_SELECTED_LINK_TYPE: 'SET_SELECTED_LINK_TYPE',
   SET_SELECTED_CAMPAIGN_TYPE: 'SET_SELECTED_CAMPAIGN_TYPE',
   RESET_DATA: 'RESET_DATA',
 };

 function digitalPRReducer(state, action) {
   switch (action.type) {
      case digitalPRActions.SET_CAMPAIGNS:
         return { 
            ...state, 
            campaignList: action.payload.campaignList,  
         };
      case digitalPRActions.SET_CAMPAIGNS_CHILD:
         return { 
            ...state, 
            campaignList: state.campaignList.map((row) => {
               if(row.month === action.payload.month) {
                  return { ...row, children: { ...row.children, data: action.payload.childCampaignList}}
               }
               return row
            }),  
         };
      case digitalPRActions.SET_CAMPAIGNS_LOADING:
         return { 
            ...state, 
            campaignList: state.campaignList.map((row) => {
               if(row.id === action.payload.campaignID) {
                  return { ...row, children: { ...row.children, loading: action.payload.loading }}
               }
               return row
            }),  
         };
      case digitalPRActions.SET_LINKS_DIALOG_OPEN:
         return { 
            ...state, 
            linksDialogOpen: action.payload.linksDialogOpen, 
         };
      case digitalPRActions.SET_SELECTED_CAMPAIGN:
         return { 
            ...state, 
            selectedCampaign: action.payload.selectedCampaign,  
         };
      case digitalPRActions.SET_CAMPAIGNS_EXPAND:
         return { 
            ...state, 
            campaignList: state.campaignList.map((row) => {
               if(row.month === action.payload.month) {
                  return { ...row, children: { ...row.children, expanded: !row.children.expanded }}
               }
               return row
            }),  
         };
      case digitalPRActions.SET_TOTAL_CAMPAIGNS:
         return { 
            ...state, 
            totalCampaigns: action.payload.totalCampaigns, 
         };
      case digitalPRActions.SET_LOADING:
         return { 
            ...state, 
            campaignsLoading: action.payload.campaignsLoading,
         };
      case digitalPRActions.SET_CAMPAIGN_FILTER:
         return { 
            ...state, 
            campaignFilters: {...state.campaignFilters, ...action.payload.campaignFilters}, 
         };

      case digitalPRActions.TOGGLE_EXPORT_BUTTON:
         return {
            ...state,
            exportDisabled: !state.exportDisabled,
         }
      case digitalPRActions.SET_LINK_LIST:
         return { 
            ...state, 
            linkList: action.payload.linkList,  
         };
      case digitalPRActions.SET_LINKS_LOADING:
         return { 
            ...state, 
            linksLoading: action.payload.linksLoading,
         };
      case digitalPRActions.SET_LINKS_BY_MONTH:
         return { 
            ...state, 
            linksByMonth: action.payload.linksByMonth, 
         };
      case digitalPRActions.SET_LINKS_BY_MONTH_LOADING:
         return { 
            ...state, 
            linksByMonthLoading: action.payload.linksByMonthLoading, 
         };
      case digitalPRActions.SET_LINK_ACQUISITIONS_BY_MONTH:
         return { 
            ...state, 
            linkAcquisitionsByMonth: action.payload.linkAcquisitionsByMonth,
         };
      case digitalPRActions.SET_LINK_ACQUISITIONS_BY_MONTH_LOADING:
         return { 
            ...state, 
            linkAcquisitionsByMonthLoading: action.payload.linkAcquisitionsByMonthLoading, 
         };
      case digitalPRActions.SET_DOMAIN_RATING_DISTRIBUTION:
         return { 
            ...state, 
            domainRatingDistribution: action.payload.domainRatingDistribution, 
         };
      case digitalPRActions.SET_DOMAIN_RATING_DISTRIBUTION_LOADING:
         return { 
            ...state, 
            domainRatingDistributionLoading: action.payload.domainRatingDistributionLoading, 
         };
      case digitalPRActions.SET_ACTIVE_ORDER_BY:
         return { 
            ...state, 
            activeOrderBy: action.payload.activeOrderBy, 
         };
      case digitalPRActions.SET_IS_VIDEO_OPEN:
         return { 
            ...state, 
            isVideoOpen: action.payload.isVideoOpen, 
         };
      case digitalPRActions.SET_VIDEO_URL:
         return { 
            ...state, 
            videoUrl: action.payload.videoUrl, 
         };
      case digitalPRActions.SET_CURRENT_TABLE:
         return { 
            ...state, 
            currentTable: action.payload.currentTable, 
         };
      case digitalPRActions.SET_CLIENT_NOTES_OPEN:
         return { 
            ...state, 
            clientNotesOpen: action.payload.clientNotesOpen, 
         };
      case digitalPRActions.SET_SELECTED_CLIENT_NOTE:
         return { 
            ...state, 
            selectedClientNote: action.payload.selectedClientNote, 
         };
      case digitalPRActions.SET_SELECTED_LINK_TYPE:
         return { 
            ...state, 
            selectedLinkType: action.payload.selectedLinkType, 
         };
      case digitalPRActions.SET_SELECTED_CAMPAIGN_TYPE:
         return { 
            ...state, 
            selectedCampaignType: action.payload.selectedCampaignType, 
         };
      case digitalPRActions.RESET_DATA:
         return {
            ...initialDigitalPRState,
         };
      default:
         return state;
   }
}

export { initialDigitalPRState, digitalPRActions, digitalPRReducer };
